var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "HqDrawer",
        {
          ref: "drawer",
          attrs: {
            title:
              _vm.status == "add"
                ? "新增"
                : _vm.status == "detail"
                ? "查看详情"
                : "编辑",
            visible: _vm.drawerVisible,
            size: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerVisible = $event
            },
            "on-cancel": _vm.cancel
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "pageform",
              staticStyle: {
                width: "90%",
                margin: "0 auto",
                padding: "12px 0 100px 0"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, rules: _vm.addruleValidate }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "section_title" }, [
                          _vm._v("学员信息")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "orderNo" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "学员订单号",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.orderNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "orderNo", $$v)
                                  },
                                  expression: "form.orderNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "studentName" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "学员姓名",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  readonly: "",
                                  "suffix-icon": "el-icon-search",
                                  disabled: _vm.status != "add"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.onOpenChoiceStudent.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.studentName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "studentName", $$v)
                                  },
                                  expression: "form.studentName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("StudentOrder", {
                        ref: "studentOrderModalRef",
                        attrs: { visible: _vm.showStudentOrderModal },
                        on: {
                          "on-ok": _vm.onGoodsDrawerOk,
                          "update:visible": function($event) {
                            _vm.showStudentOrderModal = $event
                          }
                        }
                      }),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "mobilePhone" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "学员手机号",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.mobilePhone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mobilePhone", $$v)
                                  },
                                  expression: "form.mobilePhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "subscribeSchoolName" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "成交校区",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.subscribeSchoolName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "subscribeSchoolName",
                                      $$v
                                    )
                                  },
                                  expression: "form.subscribeSchoolName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "44px" },
                              attrs: { prop: "goodsName" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "报读商品",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.goodsName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "goodsName", $$v)
                                  },
                                  expression: "form.goodsName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "section_title" }, [
                          _vm._v("教学辅导内容")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "tutoringMonth" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "menu",
                                  attrs: {
                                    "close-on-content-click": false,
                                    "return-value": _vm.form.tutoringMonth,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "tutoringMonth",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "tutoringMonth",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label: "辅导日期",
                                                    "hide-details": "auto",
                                                    outlined: "",
                                                    dense: true,
                                                    height: 32,
                                                    clearable: true,
                                                    readonly: "",
                                                    disabled:
                                                      _vm.status == "detail"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.tutoringMonth,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "tutoringMonth",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.tutoringMonth"
                                                  }
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.menu,
                                    callback: function($$v) {
                                      _vm.menu = $$v
                                    },
                                    expression: "menu"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        "no-title": "",
                                        locale: "zh-cn"
                                      },
                                      model: {
                                        value: _vm.form.tutoringMonth,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "tutoringMonth",
                                            $$v
                                          )
                                        },
                                        expression: "form.tutoringMonth"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.menu = false
                                            }
                                          }
                                        },
                                        [_vm._v("取消")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$refs.menu.save(
                                                _vm.form.tutoringMonth
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" 确认 ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "tutorName" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "辅导老师",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: _vm.status == "detail"
                                },
                                model: {
                                  value: _vm.form.tutorName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tutorName", $$v)
                                  },
                                  expression: "form.tutorName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "44px" },
                              attrs: { prop: "tutoringDuration" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "一对一辅导分钟数",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: _vm.status == "detail"
                                },
                                on: { input: _vm.changeTutoringDuration },
                                model: {
                                  value: _vm.form.tutoringDuration,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tutoringDuration", $$v)
                                  },
                                  expression: "form.tutoringDuration"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "guidanceWay" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.guidenceTypeList,
                                  "menu-props": { bottom: true, offsetY: true },
                                  label: "辅导方式",
                                  "item-text": "name",
                                  "item-value": "name",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  "clear-icon": "$clear",
                                  "hide-details": "auto",
                                  "no-data-text": "暂无数据",
                                  disabled:
                                    _vm.status == "detail" ||
                                    _vm.status == "passEdit"
                                },
                                on: { change: _vm.changeGuidenceType },
                                model: {
                                  value: _vm.form.guidanceWay,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "guidanceWay", $$v)
                                  },
                                  expression: "form.guidanceWay"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { prop: "img" } }, [
                            _c(
                              "div",
                              { staticClass: "upload-box upload-box-fujian" },
                              [
                                _vm.imgList.length < 8 &&
                                _vm.status !== "detail"
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          action: _vm.imgUploadDK.host,
                                          "show-file-list": false,
                                          "on-success": _vm.handleAvatarSuccess(),
                                          data: _vm.imgUploadDK,
                                          "before-upload": _vm.beforeAvatarUpload(),
                                          "auto-upload": "",
                                          "http-request": _vm.uploadRequest()
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.imgList.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          position: "relative",
                                          display: "flex"
                                        }
                                      },
                                      _vm._l(_vm.imgList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              "margin-right": "10px"
                                            }
                                          },
                                          [
                                            _c("el-image", {
                                              key: index,
                                              staticClass: "avatar",
                                              staticStyle: {
                                                "object-fit": "contain"
                                              },
                                              attrs: {
                                                src: item,
                                                "preview-src-list": [item]
                                              }
                                            }),
                                            _vm.status !== "detail"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                      "font-size": "20px",
                                                      color: "#fff",
                                                      "line-height": "26px",
                                                      "text-align": "center",
                                                      position: "absolute",
                                                      "border-radius": "13px",
                                                      width: "26px",
                                                      height: "26px",
                                                      right: "-10px",
                                                      top: "-10px",
                                                      "background-color": "red"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removePic(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("x")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "remark" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  outlined: "",
                                  height: 100,
                                  name: "input-7-4",
                                  label: "定向一对一辅导内容",
                                  value: "",
                                  maxlength: "100",
                                  disabled: _vm.status == "detail"
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "note" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  outlined: "",
                                  height: 80,
                                  name: "input-7-4",
                                  label: "备注",
                                  value: "",
                                  disabled: _vm.status == "detail"
                                },
                                model: {
                                  value: _vm.form.note,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _vm.status != "detail"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnLoading },
                      on: { click: _vm.save }
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }